<template>
    <div class="team_list">
        <div class="team_list_view">
            <div class="team_list_main">
                <div v-for="item in teamList" :key="item.id" @click="teamChange(item)">
                    <div :class="['team_item', currentTeam.id === item.id ? 'active' : '']">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="list_view">
            <div class="table Table_Draggable">
                <el-table :data="tableData" height="100%">
                    <template #empty>
                        <cl-no-data></cl-no-data>
                    </template>
                    <el-table-column label="" width="58px">
                        <template slot-scope="{row}">
                            <cl-avatar :src="row.avatar" height="38" width="38" around />
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('team.姓名')" prop="name" :show-overflow-tooltip="true" width="210px" />
                    <el-table-column :label="$t('team.位置')" prop="pitch">
                        <template slot-scope="{row}">
                            {{ $utils.getValueByKey(positionLinst, row.position, 'name', 'key') }}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('club.球衣号')" prop="number">
                        <template slot-scope="{row}">
                            <span class="AkrobatM">{{ row.number }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('team.出生日期')" prop="birthday">
                        <template slot-scope="{row}">
                            <span class="AkrobatM">{{ row.birthday }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('team.性别')" prop="sex">
                        <template slot-scope="{row}">
                            <span>{{ Number(row.sex) === 2 ? $t('camp.女') : $t('camp.男') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        detailsData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            teamList: [],
            currentTeam: {},
            tableData: [],
            positionLinst: [
                {
                    name: "前锋",
                    key: "forward",
                },
                {
                    name: "中场",
                    key: "midfielder",
                },
                {
                    name: "后卫",
                    key: "defender",
                },
                {
                    name: "守门员",
                    key: "goalkeeper",
                }
            ],
        }
    },
    methods: {
        async getTeamList() {
            const params = {
                tenant_id: this.detailsData.tenant_id
            }
            const { code, data } = await this.$server.campTeamListApi(params, this.detailsData.id)
            if (code === 200 && data) {
                this.teamList = data
                this.currentTeam = this.teamList[0]
                if (this.teamList.length > 0) {
                    this.getData()
                }
            }
        },
        teamChange(item) {
            this.currentTeam = item
            this.getData()
        },
        async getData() {
            this.tableData = []
            const params = {
                tenant_id: this.detailsData.tenant_id
            }
            const { code, data } = await this.$server.campPlayerListApi(params, this.currentTeam.id)
            if (code === 200 && data) {
                this.tableData = data
            }
        },
    },

    created() {
        this.getTeamList()
    },
}
</script>

<style lang="scss" scoped>
.team_list {
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .team_list_view {
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        overflow: hidden;
        background: #fff;
        border-bottom: 2px solid #e9edf3;
        border-radius: 6px 6px 0 0;
        .team_list_main {
            flex: 1;
            overflow: auto;
            display: flex;
            align-items: center;
            .team_item {
                box-sizing: border-box;
                height: 38px;
                min-width: 98px;
                text-align: center;
                padding: 0 24px;
                margin-right: 16px;
                border: 0.5px solid rgba(50, 106, 84, 0.3);
                background: rgba(50, 106, 84, 0.05);
                line-height: 36px;
                font-size: 16px;
                border-radius: 19px;
                color: $base-color-theme;
                cursor: pointer;
            }
            .active {
                background: $base-color-theme;
                color: #fff;
            }
        }
    }
    .list_view {
        flex: 1;
        background: #fff;
        border-radius: 0 0 4px 4px;
        overflow: hidden;
        .table {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
